import { Reducer, Middleware, combineReducers } from 'redux';
import {
  contact,
  message,
  message_contact,
  grouping,
  project,
  project_contact,
  project_stage,
  project_team,
  project_template,
  role,
  subscriber,
  item,
  team,
  team_contact,
  coordination,
  event,
  item_status,
  attachment,
  email,
  relationship,
  comment,
  task,
  subscription_contact,
  project_type,
  market_segment,
  comment_contact,
  stage,
  outcome,
  project_state,
  tag,
  item_tag,
  appointment,
  analytic,
  dataexport,
  organization,
  project_workflow,
} from 'store/api';
import {
  getAuthStatus,
  user,
  userSlice,
  init,
  logout,
  file,
  fileBrowserSlice,
  baseApi,
} from '@centerpiece/components';
import { historySlice } from 'store/slice/history.slice';

export const appMiddleware: Middleware<any>[] = [
  // action.middleware,
  user.middleware,
  // appointment.middleware,
  baseApi.middleware,
  // coordination.middleware,
  // attachment.middleware,
  // comment.middleware,
  // comment_contact.middleware,
  // contact.middleware,
  // dataexport.middleware,
  // email.middleware,
  // event.middleware,
  file.middleware,
  // grouping.middleware,
  // item.middleware,
  // item_tag.middleware,
  // item_status.middleware,
  // market_segment.middleware,
  // message.middleware,
  // message_contact.middleware,
  // organization.middleware,
  // outcome.middleware,
  // project_contact.middleware,
  // project_stage.middleware,
  // project_state.middleware,
  // project_team.middleware,
  // project_template.middleware,
  // project_type.middleware,
  // project_workflow.middleware,
  // project.middleware,
  // relationship.middleware,
  // role.middleware,
  // stage.middleware,
  // subscriber.middleware,
  // subscription_contact.middleware,
  // tag.middleware,
  // task.middleware,
  // // team_contact.middleware,
  // team.middleware,
];

const appReducer: Reducer<any> = combineReducers({
  // [action.reducerPath]: action.reducer,
  [user.reducerPath]: user.reducer,
  [userSlice.name]: userSlice.reducer,
  // [appointment.reducerPath]: appointment.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  // [coordination.reducerPath]: coordination.reducer,
  // [attachment.reducerPath]: attachment.reducer,
  // [comment.reducerPath]: comment.reducer,
  // [comment_contact.reducerPath]: comment_contact.reducer,
  // [contact.reducerPath]: contact.reducer,
  // [dataexport.reducerPath]: dataexport.reducer,
  // [email.reducerPath]: email.reducer,
  // [event.reducerPath]: event.reducer,
  [file.reducerPath]: file.reducer,
  [fileBrowserSlice.name]: fileBrowserSlice.reducer,
  // [grouping.reducerPath]: grouping.reducer,
  [historySlice.name]: historySlice.reducer,
  // [item.reducerPath]: item.reducer,
  // [item_tag.reducerPath]: item_tag.reducer,
  // [item_status.reducerPath]: item_status.reducer,
  // [market_segment.reducerPath]: market_segment.reducer,
  // [message.reducerPath]: message.reducer,
  // [message_contact.reducerPath]: message_contact.reducer,
  // [organization.reducerPath]: organization.reducer,
  // [outcome.reducerPath]: outcome.reducer,
  // [project_contact.reducerPath]: project_contact.reducer,
  // [project_stage.reducerPath]: project_stage.reducer,
  // [project_state.reducerPath]: project_state.reducer,
  // [project_team.reducerPath]: project_team.reducer,
  // [project_template.reducerPath]: project_template.reducer,
  // [project_type.reducerPath]: project_type.reducer,
  // [project_workflow.reducerPath]: project_workflow.reducer,
  // [project.reducerPath]: project.reducer,
  // [relationship.reducerPath]: relationship.reducer,
  // [role.reducerPath]: role.reducer,
  // [stage.reducerPath]: stage.reducer,
  // [subscriber.reducerPath]: subscriber.reducer,
  // [subscription_contact.reducerPath]: subscription_contact.reducer,
  // [tag.reducerPath]: tag.reducer,
  // [task.reducerPath]: task.reducer,
  // // [team_contact.reducerPath]: team_contact.reducer,
  // [team.reducerPath]: team.reducer,
});

const rootReducer: Reducer<any> = (state: any, action) => {
  switch (action.type) {
    case init.toString(): {
      const auth = getAuthStatus();
      if (auth) {
        return appReducer({ auth: auth }, action);
      } else {
        return appReducer({}, action);
      }
    }
    case logout.toString(): {
      return appReducer(undefined, action);
    }
    default: {
      return appReducer(state, action);
    }
  }
};

export default rootReducer;
